import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const HeroRoot = styled('div', {
    
})

export const HeroContainer = styled('div', {
    position: 'relative',
    width: '100%',
    margin: 'auto',

    '@bp2': {
        maxWidth: 'none'
    }
})

export const HeroCopy = styled('div', {
    position: 'static',
    zIndex: 1,
    color: '$accent-black',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '$3 $2 $4',

    '@bp2': {
        padding: 0,
        position: 'absolute',
        textAlign: 'left',
        top: '50%',
        left: '50px',
        transform: 'translateY(-50%)',
        color: '$accent-white',
        alignItems: 'flex-start',
        width: '602px',
    },

    '@bp3': {
        left: '100px',
    },

    '@bp4': {
        left: '50%',
        transform: 'translate(-140%,-50%)',
    }
})

export const Header = styled('h1', {
    fontSize: '$h3',
    lineHeight: '$h3',
    letterSpacing: '$h3',
    marginBottom: '12px',
    '@bp2': {
        fontSize: '$h1',
        marginTop: 0,
        lineHeight: '$h1',
        letterSpacing: '$h1',
    }
})

export const Subheader = styled(Text, {
    maxWidth: '340px',
    marginBottom: '$3',
    '@bp2': {
        maxWidth: '300px',
    }
})

export const ImageBackground = styled('div', {
    position: 'relative',
    lineHeight: 0,
    zIndex: 0,
    width: '100%',
    aspectRatio: 393/275,

    '& img': {
        objectPosition: '68% 0%'
    },

    '@bp1': {
        aspectRatio: 1440/505,

        '& img': {
            objectPosition: 'none'
        },
    },

    '@bp2': {
        width: '100%',
        height: '500px',
        aspectRatio: 'none',
    },

    '@bp3': {
        aspectRatio: 1440/505,
        height: 'auto',
    }
})